module.exports = __webpack_public_path__ + "img/internazionale.bbf7e72d.png";